// EVE-Profile-API. V3-Routen:
// - GET  /eve/profile         (returns { profile: EveProfile | null })
// - PATCH /eve/profile        (body: { profile: EveProfile })

import { apiFetch } from './api';
import { mergeWithDefaults } from './eve-profile';
import type { EveProfile } from '@/types/eve-profile';

interface ProfileResponse {
  profile: Partial<EveProfile> | string | null;
}

/**
 * Lädt das Backend-Profil. Wenn vorhanden, mit Defaults gemerged.
 * `null` wenn unauthenticated oder noch nicht gespeichert.
 */
export async function loadProfileFromBackend(accessToken: string): Promise<EveProfile | null> {
  try {
    const res = await apiFetch<ProfileResponse>('/eve/profile', { accessToken });
    const raw = res?.profile ?? null;
    if (raw == null) return null;
    // V1: Backend kann das Profil als JSON-String oder Objekt zurückgeben.
    const parsed = typeof raw === 'string' ? (JSON.parse(raw) as Partial<EveProfile>) : raw;
    return mergeWithDefaults(parsed);
  } catch {
    return null;
  }
}

/**
 * Speichert das Profil im Backend (PATCH). Fire-and-forget — wirft nicht.
 */
export async function syncProfileToBackend(
  profile: EveProfile,
  accessToken: string,
): Promise<boolean> {
  try {
    await apiFetch('/eve/profile', {
      method: 'PATCH',
      accessToken,
      json: { profile: JSON.stringify(profile) },
    });
    return true;
  } catch (e) {
    console.warn('[EveProfile] D1 sync fehlgeschlagen:', e instanceof Error ? e.message : e);
    return false;
  }
}
